import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { assetUrl } from "@shared/helper/asset-url";

interface PropsType {
  title: string;
  description: string;
  buttonText: string;
  imagePath: string;
}

@Component({
    selector: "app-driveb-generic-alert-modal",
    templateUrl: "./generic-alert-modal.component.html",
    styleUrls: ["./generic-alert-modal.component.scss"],
    standalone: false
})
export class GenericAlertModalComponent implements OnInit {
  title: string;
  description: string;
  buttonText: string;
  imgPath: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: PropsType,
    private matDialogRef: MatDialogRef<GenericAlertModalComponent>
  ) {}

  ngOnInit(): void {
    this.imgPath = assetUrl(this.data.imagePath);
    this.title = this.data.title;
    this.description = this.data.description;
    this.buttonText = this.data.buttonText;
  }

  closeDialog(isSubmitted: boolean): void {
    this.matDialogRef.close();
  }
}
